import { SortOrder } from "types/common.types";

export const makeUniversalSort =
  (normalizer: (item: any) => string | number | boolean) => (sortWay: SortOrder) => (a: any, b: any) => {
    const flag = sortWay === "asc" ? -1 : 1;
    try {
      return normalizer(a) >= normalizer(b) ? flag * -1 : flag;
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
      return 0;
    }
  };

export const bucketNameNormalizer = (item: any) => item.bucketName ?? item.name;
export const bucketSizeNormalizer = (item: any) => item.bucketSize ?? item.size;
export const objectsNormalizer = (item: any) => item.objects;
export const locationNormalizer = (item: any) => item.location;
export const replicatedNormalizer = (item: any) => (item.replicated ? 1 : 0);
export const propertiesNormalizer = (item: any) => item.properties ?? "";
export const createdNormalizer = (item: any) => new Date(item.created).getTime();

export const bucketsSortHandler = {
  bucketName: makeUniversalSort(bucketNameNormalizer),
  bucketSize: makeUniversalSort(bucketSizeNormalizer),
  name: makeUniversalSort(bucketNameNormalizer),
  size: makeUniversalSort(bucketSizeNormalizer),
  objects: makeUniversalSort(objectsNormalizer),
  location: makeUniversalSort(locationNormalizer),
  created: makeUniversalSort(createdNormalizer),
  replicated: makeUniversalSort(replicatedNormalizer),
  properties: makeUniversalSort(propertiesNormalizer),
};
